module.exports = __webpack_public_path__ + "img/tw.f02e9a98.svg";